import { Component, inject, input, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { Dialog } from 'primeng/dialog';
import { CardPersonComponent } from '../card-person/card-person.component';
import {
  FormGroup,
  ReactiveFormsModule,
  FormBuilder,
  FormsModule,
} from '@angular/forms';
import { DrawerModule } from 'primeng/drawer';
import { DetalheProfissionaisComponent } from '../detalhe-profissionais/detalhe-profissionais.component';
import { PaginatorModule } from 'primeng/paginator';
import {
  EspecialidadeFuncaoListItemDTO,
  EstadoProfissionalEnum,
  ProfissaoCatalogoListItemDTO,
  Profissional,
  ProfissionalListItemDTO,
  SectorEnum,
} from '../../../api';
import {
  ProfissionalService,
  ProfissaoCatalogoService,
  HabilitacaoAcademicaService,
  ExperienciaProfissionalService,
  ProfissionaisEnumService,
} from '../../../services';
import { Pagination } from '@app/shared/model';
import { PaginatorControlComponent } from '../../../../../shared/components/paginator-control/paginator-control.component';
import { MessageService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { FilterItem } from '@app/features-modules/gestao-bolseiros/components/api/models';
import { ExperienciaProfissional } from '@app/features-modules/gestao-de-concurso/api';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { ProfissionalSectorService } from '@app/features-modules/bolsa-de-profissionais/services/profissional-sector.service';
import { ApiService } from '@core/providers/http';
import { TagModule } from 'primeng/tag';
import { MenuModule } from 'primeng/menu';
import { EmpresaSectorService } from '@app/features-modules/bolsa-de-profissionais/services/empresa-sector.service';
import { forkJoin } from 'rxjs';
import { Toast } from 'primeng/toast';
import { AuthStore } from '@core/service/auth-store.service';

interface City {
  name: string;
  code: string;
}

@Component({
  selector: 'app-lista-profissionais',
  imports: [
    TableModule,
    TabsModule,
    DrawerModule,
    InputTextModule,
    FormsModule,
    Select,
    ButtonModule,
    DetalheProfissionaisComponent,
    PaginatorModule,
    PaginatorControlComponent,
    Dialog,
    ReactiveFormsModule,
    CommonModule,
    SearchBarComponent,
    DataVoidComponent,
    TagModule,
    MenuModule,
    Toast,
  ],
  providers: [
    ApiService,
    MessageService,
    ProfissionalService,
    ProfissionalSectorService,
    ProfissaoCatalogoService,
    HabilitacaoAcademicaService,
    ExperienciaProfissionalService,
  ],
  templateUrl: './lista-profissionais.component.html',
  styleUrl: './lista-profissionais.component.scss',
  standalone: true,
})
export class ListaProfissionaisComponent implements OnInit {
  mode = input('list');
  private auth = inject(AuthStore);
  messageService = inject(MessageService);
  profissionalenumService = inject(ProfissionaisEnumService);
  profissionalService = inject(ProfissionalSectorService);
  profissaoService = inject(ProfissaoCatalogoService);
  empresaService = inject(EmpresaSectorService);
  habilitacaoService = inject(HabilitacaoAcademicaService);
  experienciaProfissional = inject(ExperienciaProfissionalService);

  pagination: Pagination<any> = new Pagination<any>();
  isLoading: boolean = false;
  profissionais: ProfissionalListItemDTO[] = [];
  listaProfissoes: ProfissaoCatalogoListItemDTO[] = [];
  listaHabilitacoes: any[] = [];
  listaExperiencias: ExperienciaProfissional[] = [];
  listaEspecialidadeFuncao: EspecialidadeFuncaoListItemDTO[] = [];
  listaEmpresas: any[] = [];
  listaEstadoCandidatura: any[] = [];
  listaRegimeTrabalho: any[] = [];

  constructor(public fb: FormBuilder) {}

  visible: boolean = false;
  profissional: Profissional | undefined | null;
  form!: FormGroup;

  imagePreviewMap: { [id: number]: string | ArrayBuffer | null } = {}; // To store image as Base64 URL

  subsector = [
    { id: SectorEnum.NUMBER_1, designacao: 'Petróleo e Gás' },
    { id: SectorEnum.NUMBER_2, designacao: 'Recursos Minerais' },
  ];

  sortFields: any[] = [
    { label: 'codigo', value: 'codigo' },
    { label: 'Profissão de referência', value: 'designacaoFuncao' },
  ];

  groupPersonList = [
    { label: 'Responsável', value: 1 },
    { label: 'Técnico', value: 2 },
    { label: 'Operário', value: 3 },
    { label: 'Administração e Serviços', value: 4 },
  ];

  EstadoOption = [
    { id: EstadoProfissionalEnum.NUMBER_1, designacao: 'Empregado' },
    { id: EstadoProfissionalEnum.NUMBER_2, designacao: 'Não Empregado ' },
  ];

  idadeOptions = Array.from({ length: 35 - 15 + 1 }, (_, i) => ({
    label: `${i + 20} anos`,
    id: i + 20,
  }));

  filters: FilterItem[] = [
    {
      type: 'text',
      controlName: 'NumBI',
      placeholder: 'Bilhete de Identidade',
    },
    {
      type: 'text',
      controlName: 'Email',
      placeholder: 'Email',
    },
    {
      type: 'dropdown',
      controlName: 'designacaoISCO',
      placeholder: 'Profissão de Referência',
      options: this.listaProfissoes,
      optionLabel: 'designacaoISCO',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'estado',
      placeholder: 'Estado',
      options: this.EstadoOption,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'EmpresaID',
      placeholder: 'Empresa',
      options: this.listaEmpresas,
      optionLabel: 'nome',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'regime',
      placeholder: 'Regime de Trabalho',
      options: this.listaRegimeTrabalho,
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'grupoTrabalho',
      placeholder: 'Grupo de Trabalho',
      options: this.groupPersonList,
      optionLabel: 'label',
      optionValue: 'value',
    },
    {
      type: 'dropdown',
      controlName: 'habilitacao',
      placeholder: 'Habilitação Académica',
      options: this.listaHabilitacoes,
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'idade',
      placeholder: 'Idade',
      options: this.idadeOptions,
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'estadoCandidatura',
      placeholder: 'Estado da Candidatura',
      options: this.listaEstadoCandidatura,
      optionLabel: 'label',
      optionValue: 'id',
    },
  ];

  ngOnInit(): void {
    this.getProfissionais();
    this.getProfissoes();
    this.getAllEmpresas();
    //this.getExperiencias();
    // this.getHabilitacoes();
    this.loadDropdowns();

    this.form = this.fb.group({
      designacaoISCO: [null],
      estado: [null],
      EmpresaID: [null],
      regime: [null],
      grupoTrabalho: [null],
      habilitacao: [null],
      NumBI: [null],
      Email: [null],
      idade: [null],
      estadoCandidatura: [null],
    });
  }

  getProfissionais(filters?: any) {
    this.isLoading = true;
    const params = {
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
      OrderBy: filters?.OrderBy || 'id desc',
      ...filters,
    };
    this.profissionalService.getAllProfissionalGet(params).subscribe(
      (result) => {
        if (result.data) {
          this.profissionais = result.data;
          this.pagination = new Pagination<any>().deserialize(result);
          this.isLoading = false;
          // this.profissionais.forEach((prof) => {
          //   this.getPhotoByProficionalId(prof.id);
          // });
        }
      },
      (error: any) => {
        console.error('Erro ao buscar profissionais:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao buscar profissionais.',
          life: 3000,
        });
        this.isLoading = false;
      },
    );
  }

  loadDropdowns() {
    forkJoin({
      regime: this.profissionalenumService.getAllRegimeTrabalho(),
      habilitacao: this.profissionalenumService.getAllNivelHabilitacao(),
      estadoCandidatura: this.profissionalenumService.getAllEstadoCandidatura(),
    }).subscribe((response) => {
      if (response.regime?.data) {
        this.listaRegimeTrabalho = Object.entries(response.regime.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          }),
        );
        this.filters[5].options = this.listaRegimeTrabalho;
      }
      if (response.habilitacao?.data) {
        this.listaHabilitacoes = Object.entries(response.habilitacao.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          }),
        );
        this.filters[7].options = this.listaHabilitacoes;
      }
      if (response.estadoCandidatura?.data) {
        this.listaEstadoCandidatura = Object.entries(
          response.estadoCandidatura.data,
        ).map(([key, value]) => ({
          id: Number(key),
          label: value,
        }));
        this.filters[9].options = this.listaEstadoCandidatura;
      }
    });
  }

  getProfissoes() {
    this.profissaoService.list().subscribe((result) => {
      if (result.data) {
        this.listaProfissoes = result.data;
        this.filters[2].options = this.listaProfissoes.map((profissao) => ({
          ...profissao,
          designacaoISCO: `${profissao.codigoISCO} - ${profissao.designacaoISCO}`,
        }));
      }
    });
  }

  getAllEmpresas(filters?: any) {
    const params = {
      pageNumber: 1,
      pageSize: 100,
      ...filters,
    };
    this.empresaService.list(params).subscribe(
      (res: any) => {
        this.listaEmpresas = res.data;
        this.filters[4].options = this.listaEmpresas;
      },
      (error: any) => {
        console.error('Erro ao buscar empresas:', error);
      },
    );
  }

  getPhotoByProficionalId(id: number): void {
    this.profissionalService.getPhotoProfissionalIdGet(id).subscribe({
      next: (response) => {
        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreviewMap[id] = reader.result;
        };
        reader.readAsDataURL(response);
      },
      error: (err) => {
        console.error(`Erro ao carregar imagem da empresa ${id}:`, err);
        this.imagePreviewMap[id] = null;
      },
    });
  }

  // getMenuItems(profissional: any) {
  //   return [{ ...this.items[0], profissional }];
  // }

  textToUpper(text: string) {
    return text.toUpperCase();
  }

  showDetail(item: any) {
    if (this.auth.hasAny(['Consultar Profissionais'])) {
      this.profissional = item;
      this.visible = true;
    } else {
      this.profissional = item;
      this.visible = true;
      // this.messageService.add({
      //   severity: 'error',
      //   summary: 'Permissão Inválida',
      //   detail: 'Não tens permissão para efetuar esta acção',
      //   life: 3000,
      // });
    }
  }
  /*
  getHabilitacoes() {
    const profissionalId = this.profiss()?.id;
    if (profissionalId !== undefined) {
      this.habilitacaoService.getHabilitacaoAcademicaByProfissionalIdIdGet(profissionalId).subscribe(result => {
        if (result.retorno?.codigo === 200 && result.data) {
          this.listaHabilitacoes = result.data;
        }
      });
    }
  }

  getExperiencias() {
    const profissionalId = this.profiss()?.id;
    if (profissionalId !== undefined) {
      this.experienciaProfissional.getExperienciaProfissionalByProfissionalIdIdGet(profissionalId).subscribe(result => {
        if (result.retorno?.codigo === 200 && result.data) {
          this.listaExperiencias = result.data
        }
      })
    }
  }


  onChangeSector(item: SelectChangeEvent) {
    let subSector = item.value as SectorEnum;
    this.listaProfissoes = [];
    this.profissaoService.getAllProfissaoCatalogoGet(undefined, undefined, undefined, undefined, undefined, subSector ).subscribe(result => {
      if (result.data) {
        this.listaProfissoes = result.data;
      }
    })
  }*/

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== '',
      ),
    );
    console.log('Filtered values:', filters, event);
    this.getProfissionais(filters);
    this.showFilter = false;
    this.getProfissoes();
  }

  public get proficionalEstadoEmpregado() {
    return this.pagination?.data?.filter(
      (proficionalEstado: ProfissionalListItemDTO) => {
        return proficionalEstado.estado === 'Empregado';
      },
    ).length;
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getProfissionais();
  }

  showFilter: boolean = false;

  showDialog() {
    this.showFilter = true;
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }
}
